import React, { useEffect, useState } from 'react';
import { Table, Tooltip, Modal, Form, Input, Button, DatePicker, Select } from 'antd';
import { BiPencil } from 'react-icons/bi';
import { comment } from 'postcss';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
dayjs.extend(customParseFormat);
dayjs.extend(utc);



const { TextArea } = Input;
const handleChange = value => {
    console.log(`selected ${value}`);
};
export default function StatusTable({ tableData }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [selectedData, setSelectedData] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const toggleEdit = (data) => {
        console.log("Data obtained", data);
        setSelectedData(data);
        form.setFieldsValue({
            project_Name: data.projectName,
            Task_Name: data.taskName,
            comments_Date: data.commentDate,
            comments_Hours: data.commentHours,
            content: data.content,
        })
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const handleSubmit = (values) => {
        
        // setIsModalOpen(false);
        const payload = {
            changedBy: localStorage.getItem("employee_id"),
            clientId: selectedData.clientId,
            clientName: selectedData.clientName,
            projectId: selectedData.projectId,
            projectName: selectedData.projectName,
            taskId: selectedData.taskId,
            taskName: selectedData.taskName,
            commentId: selectedData.commentId,
            content: values.content,
            commentHours: selectedData.commentHours,
            approvedStatus: 0,
            commentDate: selectedData.commentDate
        }
        console.log('Form submitted:', payload);
    };



    const columns = [
        {
            title: 'Projects',
            dataIndex: 'Projects',
            key: 'Projects',
        },
        {
            title: 'Tasks',
            dataIndex: 'Task',
            key: 'Task',
        },
        {
            title: 'Date',
            dataIndex: 'Date',
            key: 'Date',
        },
        {
            title: 'Comments',
            dataIndex: 'Comments',
            key: 'Comments',
        },
        {
            title: 'Hours',
            dataIndex: 'Hours',
            key: 'Hours',
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            render: (status) => (
                <div className={status == 1 ? 'approved-tag' : status == 2? 'deny-tag' :"Pending-tag"}> 
                    {status == 1 ? 'Approved' : status == 2 ? 'Denied' : status == 4 ? "Task is Removed " : status == 5 ? "Project is Expire Or Removed" :"Pending"}
                </div>
            ),
        },
        // {
        //     title: 'Action',
        //     key: 'action',
        //     render: (_, record) => (
        //         record.approvedStatus !== 1 ? (
        //             <div className="flex justify-start">
        //                 <Tooltip title="Edit">
        //                     <BiPencil
        //                         onClick={() => toggleEdit(record)}
        //                         className="text-[15px] text-[#555] cursor-pointer"
        //                     />
        //                 </Tooltip>
        //             </div>
        //         ) : null
        //     ),
        // }
    ];


    // useEffect(() => {
    //     function flattenComments(data) {
    //         const result = [];

    //         data.forEach(client => {
    //             client.projects.forEach(project => {
    //                 project.tasks.forEach(task => {
    //                     task.comments.forEach(comment => {
    //                         result.push({
    //                             clientId: client.clientId,
    //                             clientName: client.clientName,
    //                             projectId: project.projectId,
    //                             projectName: project.projectName,
    //                             taskId: task.taskId,
    //                             taskName: task.taskName,
    //                             commentId: comment.commentId,
    //                             content: comment.content,
    //                             commentHours: comment.commentHours,
    //                             approvedStatus: comment.approvedStatus,
    //                             commentDate: comment.commentDate
    //                         });
    //                     });
    //                 });
    //             });
    //         });

    //         return result;
    //     }

    //     if (tableData && tableData.length > 0) {
    //         const result = flattenComments(tableData);
    //         setFilteredData(result);
    //     }

    // }, [tableData])

    // Filter out deleted/removed entries (status 4 and 5)
    useEffect(() => {
        if (tableData && tableData.length > 0) {
            const filtered = tableData.filter(item => item.Status !== 4 && item.Status !== 5);
            setFilteredData(filtered);
        }
    }, [tableData]);

    return (
        <>
            <div className='bg-[#fff] status-table'>
                <div className='px-[10px] py-[10px]'>
                    <span class="page-heading">APPROVAL STATUS</span>
                </div>

                <Table
                    columns={columns}
                    dataSource={filteredData}   
                    pagination={false}
                />
            </div>

            <Modal
                title="Edit"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={false}
                maskClosable={false}
                keyboard={false}
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <div className='grid grid-cols-2 gap-2'>
                        <Form.Item
                            label="Project Name"
                            name="project_Name"
                            rules={[{ required: true, message: 'Enter a Project' }]}
                        >
                            <Input className="h-10" placeholder="Enter project name" readOnly disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Task Name"
                            name="Task_Name"
                            rules={[{ required: true, message: 'Enter Task Name' }]}
                        >
                            <Input
                                className="h-10" placeholder="Enter Task Name"
                                readOnly
                                disabled
                            />
                        </Form.Item>
                    </div>
                    <div className='grid grid-cols-2 gap-2'>
                        <Form.Item
                            label="Date"
                            name="comments_Date"
                            rules={[{ required: true, message: 'Select Date' }]}
                        >
                            <Input className='w-full h-[40px]' readOnly disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Hours"
                            name="comments_Hours"
                            rules={[{ required: true, message: 'Enter a Hours' }]}
                        >
                            <Input 
                                className="h-10" placeholder="Enter a Hours"
                                readOnly={true}
                                disabled
                            />
                        </Form.Item>
                    </div>

                    <Form.Item
                        label="Comment"
                        name="content"
                        rules={[{ required: true, message: 'Enter a Comment' }]}
                    >
                        <TextArea />
                    </Form.Item>



                    <Form.Item className="text-right footer-form-item">
                        <Button
                            type="default"
                            onClick={handleCancel}
                            style={{ marginRight: '8px' }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
